import { useQueries, UseQueryOptions, UseQueryResult } from 'react-query';

import { useWeb3 } from 'clients/web3';
import { getTokenContractByAddress } from 'clients/contracts';
import { getBalanceOf, GetBalanceOfOutput } from 'clients/api';
import FunctionKey from 'constants/functionKey';
import { Erc20 } from 'types/contracts';
import { BRN_VAULT_PROXY_CONTRACT_ADDRESS } from '../constants';

export interface UseGetBrnVaultPoolBalancesInput {
  stakedTokenAddresses: (string | undefined)[];
}

export type UseGetBrnVaultPoolBalancesOutput = UseQueryResult<GetBalanceOfOutput>[];

const useGetBrnVaultPoolBalances = ({
  stakedTokenAddresses,
}: UseGetBrnVaultPoolBalancesInput): UseGetBrnVaultPoolBalancesOutput => {
  const web3 = useWeb3();

  // Fetch total amount of tokens staked in each pool
  const queries: UseQueryOptions<GetBalanceOfOutput>[] = stakedTokenAddresses.map(
    stakedTokenAddress => {
      const tokenContract = stakedTokenAddress
        ? getTokenContractByAddress(stakedTokenAddress, web3)
        : undefined;

      return {
        queryFn: () =>
          getBalanceOf({
            tokenContract: tokenContract || ({} as Erc20),
            accountAddress: BRN_VAULT_PROXY_CONTRACT_ADDRESS,
          }),
        queryKey: [
          FunctionKey.GET_BALANCE_OF,
          BRN_VAULT_PROXY_CONTRACT_ADDRESS,
          stakedTokenAddress,
        ],
        enabled: !!tokenContract,
      };
    },
  );

  return useQueries(queries);
};

export default useGetBrnVaultPoolBalances;
